var app = angular.module('directives.sendreceipt', []);

    require('./directives/sendreceipt.directive.js');
    require('./stylesheets/styles.sass');

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/sendReceipt/index.js
 ** module id = 221
 ** module chunks = 1
 **/